<template>
  <div class="echartContent" v-loading="loading" id="echart"></div>
</template>

<script>
import { markStore } from '@/utils/echart'
import { isEmpty, timetransition } from '@/utils/common'
import { magnetismValTypeConvert }  from '@/utils/convert'
import { TempUtils } from '@/utils/TempUtil.js';
export default {
  // props: ['echartObj', 'options', 'unitObj', 'loading', 'pageAsync'],
  props: {
    echartObj: {},
    options: {
      type: Object,
      default: () => ({})
    },
    unitObj: {},
    loading: {},
    pageAsync: {}
  },
  watch: {
    echartObj (newVal) {
      // if (!this.pageAsync) {
      const EchartData = []
      // 区域范围
      let rangeData = []
      //   maxVal = 0,
      //   minVal = 0
      // maxVal =
      //   newVal.data.length > 0 && newVal.data[0].max ? newVal.data[0].max : ''
      // minVal =
      //   newVal.data.length > 0 && newVal.data[0].min ? newVal.data[0].min : ''
      const pieces = markStore(newVal.data)
      if (newVal.data && newVal.data.length > 0) {
        newVal.data.forEach(item => {
          EchartData.push({
            value: [this.$timetransition(item.collectTime), TempUtils.convertToCelsius(item.val,this.unitObj.unit)],
            name: this.$timetransition(item.collectTime),
            max: !item.max ? '' : TempUtils.convertToCelsius(item.max,this.unitObj.unit),
            min: !item.min ? '' :TempUtils.convertToCelsius(item.min,this.unitObj.unit),
            no: item.no
          })
        })

        rangeData = newVal.rangeData.map(item => {
          return [
            {
              xAxis: this.$timetransition(item.minCollectTime),
              yAxis: !item.minVal ? '' :  TempUtils.convertToCelsius(item.minVal,this.unitObj.unit)
            },
            {
              xAxis: this.$timetransition(item.maxCollectTime),
              yAxis: !item.maxVal ? '' :  TempUtils.convertToCelsius(item.maxVal,this.unitObj.unit)
            }
          ]
        })
      }
      this.echartFn(EchartData, rangeData, pieces)
      // }
    }
  },
  data () {
    return {
      resizeTimer: null,
      // 原生数据 vue无法监测到Object的内部变化 将base64图片放在里面
      raw: {}
    }
  },
  methods: {
    echartFn (data = [], rangeData, pieces) {
      let valMax = 0
      let valMin = 0
      let Chart
      const _this = this // 这里的this注意一下  让他指回dom   否则只会相应最后一个
      if (rangeData.length > 0) {
        valMax = Math.max.apply(
          Math,
          rangeData.flat().map(item => item.yAxis)
        )
        valMin = Math.min.apply(
          Math,
          rangeData.flat().map(item => item.yAxis)
        )
      }
      // 消除浏览器警告
      this.$echarts.dispose(document.getElementById('echart'))
      Chart = document.getElementById('echart')
      const myChart = this.$echarts.init(Chart)
      if (data.length === 0) {
        Chart.innerHTML = $t('public.no_data')
        Chart.style.cssText =
          'text-align:center; color: #999; border: none;line-height: 300px'
        Chart.removeAttribute('_echarts_instance_')
        return
      }
      const seriesItem = {
        // sampling: 'lttb',
        data: data,
        type: 'line',
        smooth: true,
        showSymbol: false,

        // name: $t('integration.line_chart'),
        markPoint: {
          data: [
            {
              type: 'max',
              name: 'Max'
            },
            {
              type: 'min',
              name: 'Min'
            }
          ],
          label: {
            normal: {
              formatter: (param) => {
                if(this.unitObj.key === 'magnetism'){
                  return  param.data.value === 1 ? this.$t('public.open') : this.$t('public.close')
                }else{
                  return  param.data.value
                }
              }
            }
          }
        },
        // itemStyle: {
        //   normal: {
        //     color: 'var(--primary-color)',
        //     lineStyle: { color: 'var(--primary-color)' }
        //   }
        // },
        markArea: {
          itemStyle: {
            color: 'var(--primary-color)',
            opacity: 0.3
          },
          silent: true,
          data: rangeData || []
        }
      }
      const option = {
        // 图表位置
        grid: {
          left: '4%',
          right: '4%',
          bottom: '10%'
        },
        dataZoom: [
          {
            // 启用数据区域缩放
            type: 'inside',
            realtime: true,
            filterMode: 'none',
            start: 0,
            end: 100
          },
          {
            type: 'slider',
            realtime: true,
            // backgroundColor: 'rgba(48,78,114,0.4)',
            dataBackground: {
              areaStyle: {
                color: 'var(--primary-color)'
              }
            }
          }
        ],
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            restore: {}
          }
        },
        // 拐点提示窗
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            animation: false
          },
          formatter: params => {
            params = params[0]

            if (params.value[1] === '---') {
              return ''
            }
            const no = params.data.no
            console.log(no)
            return (
              $t('public.time') +
              ':' +
              timetransition(params.name) +
              '<br>' +
              `${$t('device.current_probe_value')}: ${this.unitObj.key === 'magnetism'? magnetismValTypeConvert(params.value[1]) : params.value[1] + this.unitObj.unit}` +
              '<br>' +
              `${$t('integration.monitoring_interval')}: ${isEmpty(params.data.min) ? '' : params.data.min }${
                this.unitObj.unit
              } - ${isEmpty(params.data.max) ? '' :  params.data.max }${
                this.unitObj.unit
              }` +
              '<br />' +
              (no ? `${$t('integration.equipment_no')}:` + no : '')
            )
          }
        },
        xAxis: {
          type: 'time'
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          min: function (value) {
            if (valMin <= 0 && value.min < 0) {
              return valMin < value.min ? valMin : value.min
            } else if (valMin > 0 && value.min > 0) {
              return 0
            } else if (valMin < 0 && value.min > 0) {
              return valMin || 0
            } else if (valMin >= 0 && value.min < 0) {
              return value.min || 0
            } else {
              return 0
            }
          },
          max: function (value) {
            return valMax > value.max ? valMax : value.max
          },
          name: this.unitObj.yText,
          axisLine: {
            lineStyle: {
              color: 'var(--primary-color)',
              width: 1.8
            }
          }
        },
        visualMap: [
          {
            type: 'piecewise',
            show: false,
            dimension: 0,
            seriesIndex: 0,
            pieces: pieces
          }
        ],
        series: [seriesItem],
        ...this.options
      }
      myChart.setOption(option)
      // 浏览器适配
      window.addEventListener('resize', () => {
        if (_this.resizeTimer) clearTimeout(_this.resizeTimer)
        _this.resizeTimer = setTimeout(() => {
          myChart.resize()
        }, 100)
      })
      myChart.resize()
      // 图片保存方案 暂时先注掉  将base64保存到内存  后面点击的时候再进行下载
      this.raw.base64 = myChart.getDataURL({
        type: 'jpeg',
        backgroundColor: 'white'
      })
      // downloadImage(base64, 'test.jpeg')
    },
    // 获取Echart图表  refs调用
    getChart () {
      return this.raw.base64
    }
  }
}
</script>

<style lang="scss" scoped>
.echartContent {
  height: 300px;
  border: 1px solid #ccc;
  margin-bottom: 15px;
}
</style>
